import React from "react";
import { Card, CardHeader, CardBody, Row, Col, Button, Input, Label } from "reactstrap";

const ConditionSelector = ({ 
  title, 
  idPrefix, 
  availableConditions, 
  selectedConditions, 
  onToggle, 
  onSelectAll 
}) => {
  return (
    <Card>
      <CardHeader className="d-flex justify-content-between align-items-center">
        <h5 className="mb-0">{title}</h5>
        <div className="d-flex align-items-center gap-2">
          <Button size="sm" color="outline-danger" onClick={() => onSelectAll(false)}>
            Uncheck all
          </Button>
          <Button size="sm" color="outline-primary" className="me-2" onClick={() => onSelectAll(true)}>
            Check all
          </Button>
        </div>
      </CardHeader>
      <CardBody>
        <Row>
          {availableConditions.map(cond => (
            <Col sm={6} key={`${idPrefix}-${cond}`}>
              <div className="form-check mb-2">
                <Input 
                  type="checkbox" 
                  id={`${idPrefix}-${cond}`} 
                  checked={selectedConditions.includes(cond)}
                  onChange={() => onToggle(cond)}
                />
                <Label className="form-check-label ms-2" htmlFor={`${idPrefix}-${cond}`}>
                  {cond}
                </Label>
              </div>
            </Col>
          ))}
        </Row>
      </CardBody>
    </Card>
  );
};

export default ConditionSelector;